import styled from "@emotion/styled";
import { NextPage } from "next";
import WebpImage from "../base/WebpImage";

export interface LogoProps {
	pro?: boolean;
}

const Logo: NextPage<LogoProps> = ({ pro = false }) => {
	const logo = pro
		? "/onepoint/assets/images/logo/h-logo_bl.png"
		: "/onepoint/assets/images/logo/h-logo.png";

	return (
		<LogoContainer>
			<div className="h-logo-wrap-div">
				<div className="h-logo-wrap">
					<a href="/">
						<WebpImage src={logo} alt="logo" />
					</a>
				</div>
			</div>
		</LogoContainer>
	);
};

export default Logo;

const LogoContainer = styled.div`
	.h-logo-wrap-div {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.h-logo-wrap img {
		height: 25px;
	}

	.shortconsulting-box {
		margin-left: 12px;
		display: inline-flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.shortconsulting {
		position: relative;
	}

	.beta {
		background-color: var(--primary);
		padding: 3px 8px;
		border-radius: 20px;
		display: flex;
		width: fit-content;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-left: 5px;
		margin-right: 17px;
		position: absolute;
		right: -20px;
		top: -20px;

		div {
			font-weight: bold;
			color: white;
			font-size: 10px;
			line-height: 10px;
			text-align: center;
		}
	}

	@media (max-width: 975px) {
		.h-logo-wrap img {
			height: 20px;
		}

		.h-logo-wrap {
			height: fit-content;
			display: block;
		}
	}
`;
